import { updateObject } from 'utils/updateObject'
import setFilters from 'store/reducer-utils/setFilters'
import { List } from 'immutable'

const initialState = {
  loading: true,
  data: [],
  pagination: {
    offset: 0,
    limit: 50,
    total: 0,
  },
  filters: null,
}

const setUserPaymentProfiles = (state, { payload }) =>
  updateObject(state, {
    ...payload,
    data: List(state.data).concat(List(payload.data)).toJS(),
    loading: false,
  })

const setPaymentProfilesFilter = (state, action) => {
  const filteredPayload = state?.filters
    ? [...action.payload].filter(
        (filter) => Object.keys(state.filters).indexOf(filter.fieldName) > -1,
      )
    : action.payload

  return setFilters(state, { ...action, payload: filteredPayload })
}

const setLoading = (state, { payload }) => updateObject(state, payload)

const dropPaymentProfilesList = (state) =>
  updateObject(state, {
    data: [],
    pagination: {
      offset: 0,
      limit: 50,
      total: 0,
    },
  })

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'USER/USER_PAYMENT_PROFILES_SET_LOADING':
      return setLoading(state, action)
    case 'USER/SET_USER_PAYMENT_PROFILES':
      return setUserPaymentProfiles(state, action)
    case 'USER/PAYMENT_PROFILES_SET_FILTER':
      return setPaymentProfilesFilter(state, action)
    case 'USER/DROP_USER_PAYMENT_PROFILES':
      return dropPaymentProfilesList(state, action)
    default:
      return state
  }
}

export default reducer
